module.exports = __webpack_public_path__ + "media/images/introduction_pc-23942cb7ebf47ddfb697d98de2659473.png";